import { useTheme } from "@emotion/react";
import useStyles from "./styles";

export default function NocLinks() {
  const theme = useTheme();
  const styles = useStyles(theme);
  return <></>;
}
